<template>
  <div id="page-creator">
    <div class="is-cs-2 has-text-centered has-text-weight-bold is-c-text">ショップを新規作成</div>
    <div class="input-page-id">
      <div v-if="false">{{ url }}<span class="has-text-weight-bold">{{ page.id }}</span></div>
      <label class="has-text-weight-bold">希望ショップID（URLに使用）</label><br>
      <input type="url" v-model="page.id">
      <p class="is-cs-5 is-c-alert-text" :class="{'is-invisible': !(disabled && validId)}">！ 既に取得されているIDです</p>
      <p class="is-cs-5" :class="{'is-invisible': validId}">※6文字以上の半角英小文字数字、アンダーバー「 _ 」で 入力してください。 </p>
      <p class="is-cs-5 is-c-alert-text" v-if="!countPage">※これ以上ショップを作成出来ません。 </p>
    </div>
    <div class="has-text-centered">
      <button class="button is-rounded is-c-primary is-cs-4 is-large" :disabled="disabled || !validId || !countPage" @click="createPage">
        ショップを作成する
        <span class="icon">
          <i class="fas fa-2x fa-plus-circle"></i>
        </span>
      </button>
    </div>
  </div>
</template>

<script>
import Vuex from 'vuex'
import { db, mixin } from './common.js'
export default {
  mixins: [mixin],
  data: () => ({
    page: {id: ''}
  }),
  computed: Vuex.mapState({
    url: 'cachalogUrl',
    disabled: 'disablePageCreate',
    providerData: 'providerData',
    user: 'user',
    validId () {
      return this.page.id && this.page.id.match(/^[0-9a-z_]{6,30}$/)
    },
    countPage () {
      return !this.user.pages || this.user.pages.length < 100
    }
  }),
  watch: {
    'page.id' (value) {
      if (!this.validId) {
        return
      }
      db.doc('pages/' + this.page.id).get()
        .then(doc => {
          if (doc.exists) {
            this.$store.commit('disablePageCreate', true)
            throw new Error(this.page.id + ' is exists.')
          } else {
            this.$store.commit('disablePageCreate', false)
          }
        })
        .catch(error => {
          this.$store.commit('disablePageCreate', true)
          console.error(error)
        })
      return value
    }
  },
  methods: {
    createPage () {
      this.$store.dispatch('createPage', this.page)
    }
  },
  created  () {
    if (!this.user.uid || this.providerData.isAnonymous) {
      this.$router.replace({name: 'sign-in'})
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/page-creator.vue